import { Collapse, Row, Text, theme } from '@/components';
import { useProjectsSearchStore } from '@/features/search/_stores/projects-search-store';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { ProjectSearchFormType } from '../../../../_models/projects-search';
import type { SharedSearchFormType } from '../../../../_models/shared-search';
import { unNeedActivityIndicatorSearch } from '../../../../_utils/activity-indicator-conditions';
import { ActivityIndicatorDataNatureTypeColField } from './ActivityIndicatorDataNatureTypeColField';
import { ActivityIndicatorKeywordColField } from './ActivityIndicatorKeywordColField';
import { ActivityIndicatorTermColField } from './ActivityIndicatorTermColField';
import { ActivityIndicatorTypeColField } from './ActivityIndicatorTypeColField';
const KEY = 'indicator-search-panel';

export const ActivityIndicatorSearch: FC = () => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const { openActivityIndicatorAccordion, setOpenActivityIndicatorAccordion } =
    useProjectsSearchStore();

  const { control } = useFormContext<SharedSearchFormType>();
  const sheetType = useWatch({ control, name: 'sheetType' });

  const { control: controlProject } = useFormContext<ProjectSearchFormType>();
  const fundSheetType = useWatch({
    control: controlProject,
    name: 'fundSheetType',
  });

  if (unNeedActivityIndicatorSearch({ sheetType, fundSheetType })) {
    return null;
  }

  return (
    <Collapse
      activeKey={openActivityIndicatorAccordion ? KEY : undefined}
      expandIcon={({ isActive }) =>
        isActive ? (
          <DownOutlined style={{ color: token.colorPrimary, fontSize: 12 }} />
        ) : (
          <RightOutlined style={{ color: token.colorPrimary, fontSize: 12 }} />
        )
      }
      style={{
        background: token.colorBgBase,
        borderRadius: 0,
      }}
      onChange={(e) => {
        setOpenActivityIndicatorAccordion(!!e.length);
      }}
      items={[
        {
          key: KEY,
          id: 'indicator-search-panel',
          label: (
            <Text color="primary" text={t('search-condition-effect-path')} />
          ),
          style: { borderRadius: 0, background: token.colorBorderBg },
          children: (
            <Row gutter={16}>
              <ActivityIndicatorTypeColField />
              <ActivityIndicatorTermColField />
              <ActivityIndicatorDataNatureTypeColField />
              <ActivityIndicatorKeywordColField />
            </Row>
          ),
        },
      ]}
    />
  );
};
